import {Component} from '@angular/core';
import {PrimeNgImportsModule} from '../../../../sdk/src/prime-ng-imports';
import {IBaseComponent} from '../../../../sdk/src/components/ibase/ibase.component';
import {LocationUtils} from '../../utils/location.util';
import {ECpmCLocationTypeApiEnum} from '../../../../gen/cpm-c-api-ts/src/enums/c-customer/cpmc-location.api-enums';
import {CpmCOrganizationsNumbersApiSchema} from '../../../../gen/cpm-c-api-ts/src/schemas/c-customer/cpmc-organization.api-schemas';
import {firstValueFrom} from 'rxjs';
import {CpmCOrganizationApiService} from '../../../../gen/cpm-c-api-ts/src/services/c-customer/cpmc-organization.api-service';

@Component({
    selector: 'app-customer-organizations-numbers',
    templateUrl: './customer-organizations-numbers.component.html',
    styleUrl: './customer-organizations-numbers.component.scss',
    imports: [PrimeNgImportsModule]
})
export class CustomerOrganizationsNumbersComponent extends IBaseComponent {
    protected readonly LocationUtils = LocationUtils;
    protected readonly ECPMLocationTypeApiEnum = ECpmCLocationTypeApiEnum;

    // ===============================================================
    // ===============================================================

    protected numbers?: CpmCOrganizationsNumbersApiSchema;

    // ===============================================================
    // ===============================================================

    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    protected override async onReady(): Promise<void> {
        await this.globalsService.sessionService.getRouteContextIsReadyPromise();
        this.numbers = await firstValueFrom(CpmCOrganizationApiService.getOrganizationsNumbers());
    }
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}
}
